// let baseUrl = 'http://go.asqy.net'
import $tool from './tool.js'
import $store from './store.js'
import $router from "../router/index.js"
import {
  Toast
} from 'mint-ui';
import {
  bus
} from "../bus.js";
import {
  japibaseUrl,
  baseUrl,
  baseImgPath,
  ossurl
} from './env';
// let baseUrl = ''
function getQueryVariable (variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) { return pair[1]; }
  }
  return (false);
}
//渠道来源类型保存
if (getQueryVariable('channelType')) {
  sessionStorage.setItem("channel", getQueryVariable('channelType'));
}

let vm = null
let u = navigator.userAgent
let lang = localStorage.getItem("lang") || 'zh-cn';
let channel = sessionStorage.getItem("channel") || "0"
const sendThis = (_this) => {
  vm = _this
}

console.log("uuu" + u)


const fetchql = {
  clearToken: function () {
    $store.setstate.token('')
    localStorage.setItem("token", '');

    $store.setstate.userinfo({})
  },
  hasura: function ({
    fn,
    variables,
  }) {
    return fetch(`${baseUrl}/fetchHandler`, {
      method: 'POST',
      headers: {
        "Authorization": "Bearer " + $store.state.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "Channel-Type": channel,
        "Source-Type": lang == 'zh-cn' ? '2' : "11",
        "language": lang
      },
      body: JSON.stringify({
        fn: fn || '',
        variables: variables,
      }),
    }).then(async function (response) {
      //toekn过期
      if (response.status == 200) {
        let result = await response.json()
        if (result.code == 0) {
          return result
        } else if (result.code == 101) {
          if (u.indexOf('mints') == -1) {
            vm.showIsModal();//显示kyc弹窗
          }
          return result
        } else {
          console.log(result)
          Toast({
            message: result.msg,
          });
          return result
        }
      }
      localStorage.setItem("token", '');
    }).catch(function (e) {
      Toast({
        message: "网络连接失败",
      });
      return e
    })
  },
  post: function (
    fn,
    variables,
  ) {
    return fetch(`${baseUrl}/${fn}.html`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + $store.state.token,
        'Content-Type': 'application/json',
        "Channel-Type": channel,
        "Source-Type": lang == 'zh-cn' ? '2' : "11",
        "language": lang
      },
      body: JSON.stringify(
        variables
      ),
    }).then(async function (response) {
      if (response.status == 200) {
        let result = await response.json()
        if (result.code == 0) {
          return result
        } else if (result.code == 101) {
          if (u.indexOf('mints') == -1) {
            vm.showIsModal();//显示kyc弹窗
          }
          return result
        } else {
          Toast({
            message: result.msg,
          });
          return result
        }
      }
    }).catch(function (e) {
      Toast({
        message: "网络连接失败",
      });
      return e
    })
  },
  Post: function (
    fn,
    variables,
    noMsg,
    inApp
  ) {
    return fetch(`${baseUrl}/${fn}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + $store.state.token,
        'Content-Type': 'application/json',
        "Channel-Type": channel,
        "Source-Type": lang == 'zh-cn' ? '2' : "11",
        "language": lang
      },
      body: JSON.stringify(
        variables
      ),
    }).then(async function (response) {
      if (response.status == 200) {
        let result = await response.json()
        if (result.code == 0) {
          return result
        } else if (result.code == 3) {
          return result
        } else if (result.code == 101) {
          if (u.indexOf('mints') == -1) {
            vm.showIsModal();//显示kyc弹窗
          }
          return result
        } else {
          if (noMsg != 'noMsg') {
            Toast({
              message: result.msg,
            });
          }
          return result
        }
      }
    }).catch(function (e) {
      if (noMsg != 'noMsg') {
        Toast({
          message: "网络连接失败",
        });
      }
      return e
    })
  },
  japiFetch: function (
    method,
    fn,
    variables,
    noMsg
  ) {
    return fetch(`${japibaseUrl}/${fn}`, {
      method: method,
      headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + $store.state.token,
        'Content-Type': 'application/json',
        "Channel-Type": channel,
        "Source-Type": lang == 'zh-cn' ? '2' : "11",
        "language": lang
      },
      body: JSON.stringify(
        variables
      ),
    }).then(async function (response) {
      console.log(response)
      if (response.status == 200) {
        let result = await response.json()
        if (result.code == 0) {
          return result
        } else if (result.code == 3 || result.code == 4) {
          return result
        } else if (result.code == 101) {
          if (u.indexOf('mints') == -1) {
            vm.showIsModal();//显示kyc弹窗
          }
          return result
        } else {

          return result
        }
      }
    }).catch(function (e) {
      return e
    })
  },
  japi: function (
    fn,
    variables,
    noMsg
  ) {
    return fetch(`${japibaseUrl}/${fn}`, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + $store.state.token,
        'Content-Type': 'application/json',
        "Channel-Type": channel,
        "Source-Type": lang == 'zh-cn' ? '2' : "11",
        "language": lang
      },
      body: JSON.stringify(
        variables
      ),
    }).then(async function (response) {
      if (response.status == 200) {
        let result = await response.json()
        if (result.code == 0) {
          return result
        } else if (result.code == 3 || result.code == 4) {
          return result
        } else if (result.code == 101) {
          if (u.indexOf('mints') == -1) {
            vm.showIsModal();//显示kyc弹窗
          }
          return result
        } else {

          return result
        }
      }
    }).catch(function (e) {

      return e
    })
  },



  download: function (
    fn,
    variables,
  ) {
    return fetch(`${fn}`, {
      method: 'POST',
      headers: {
        'accept-ranges': 'bytes',
        "Authorization": "Bearer " + $store.state.token,
        'Content-Type': 'application/octet-stream',
        "Channel-Type": channel,
        "Source-Type": lang == 'zh-cn' ? '2' : "11",
        "language": lang
      },
      body: JSON.stringify(
        variables
      ),
    }).then(async function (response) {
      if (response.status == 200) {
        let result = await response.json()
        if (result.code == 401) {
          if (u.indexOf('mints') == -1) {
            fetchql.clearToken();
          }
          return false
        } else if (result.code == 0) {
          return result
        } else if (result.code == 3) {
          return result
        } else {
          Toast({
            message: result.msg,
          });
          return result
        }
      }
    }).catch(function (e) {
      Toast({
        message: "网络连接失败",
      });
      return e
    })
  },
  Get: function (
    fn,
    variables,
    noMsg
  ) {
    return fetch(`${baseUrl}/${fn}`, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + $store.state.token,
        'Content-Type': 'application/json',
        "Channel-Type": channel,
        "Source-Type": lang == 'zh-cn' ? '2' : "11",
        "language": lang
      },
      body: JSON.stringify(
        variables
      ),
    }).then(async function (response) {
      if (response.status == 200) {
        let result = await response.json()
        if (result.code == 401) {
          if (u.indexOf('mints') == -1) {
            fetchql.clearToken();
            location.href = "/login?" + location.href.slice(location.href.lastIndexOf("/"));
          }
          return false
        } else if (result.code == 0) {
          return result
        } else if (result.code == 3 || result.code == 4) {
          return result
        } else if (result.code == 101) {
          if (u.indexOf('mints') == -1) {
            vm.showIsModal();//显示kyc弹窗
          }
          return result
        } else {

          return result
        }
      }
    }).catch(function (e) {

      return e
    })
  },
  logs: async function (obj, err) {
  },
  upload: async function (obj) {
    return fetch(`${baseUrl}/upload.html`, {
      method: 'POST',
      body: obj,
    }).then(function (response) {
      return response.json()
    }).catch(function (e) {
      return e
    })
  },
  uploadVideo: async function (url, obj) {
    return fetch(`${baseUrl}/${url}`, {
      method: 'POST',
      //         headers: {
      // 'Accept': 'application/json',
      //             'Content-Type': 'multipart/form-data',
      //         },
      // body: JSON.stringify(obj),
      body: obj,
    }).then(function (response) {
      return response.json()
    }).catch(function (e) {
      return e
    })
  },
  md: async function (filename) {
    return fetch(`/static/${filename}`, {
      method: 'get',
    }).then(function (response) {
      return response.text();
    })
  },
  GetCheckuser: function (
    fn,
    variables,
    noMsg
  ) {
    return fetch(`${baseUrl}/checkuser`, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + $store.state.token,
        'Content-Type': 'application/json',
        "Channel-Type": channel,
        "Source-Type": lang == 'zh-cn' ? '2' : "11",
        "language": lang
      },
      body: JSON.stringify({
        ip: returnCitySN["cip"]
      }),
    }).then(async function (response) {
      if (response.status == 200) {
        let result = await response.json()
        if (result.code == 401) {
          if (u.indexOf('mints') == -1) {
            fetchql.clearToken();
            location.href = "/login?" + location.href.slice(location.href.lastIndexOf("/"));
          }
          return false
        } else if (result.code == 0) {
          return
          //判断是手机端还是pc端
          function isPcOrMobile () {
            if (window.navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )) {
              return true; // 移动端
            } else {
              return false; // PC端
            }
          };
          var jumpUrlObj = {
            "wap.": {
              zh: isPcOrMobile() ? "https://wap.mintstech.art" : "https://test.mintstech.art",
              else: isPcOrMobile() ? "https://wapinternational.mintstech.art" : "https://testinternational.mintstech.art",
              normal: isPcOrMobile() ? "https://wap.mintstech.art" : "https://test.mintstech.art",
            },
            "wapinternational.": {
              zh: isPcOrMobile() ? "https://wap.mintstech.art" : "https://test.mintstech.art",
              else: isPcOrMobile() ? "https://wapinternational.mintstech.art" : "https://testinternational.mintstech.art",
              normal: isPcOrMobile() ? "https://wapinternational.mintstech.art" : "https://testinternational.mintstech.art",
            },
            "m.mintstech.cn": {
              zh: isPcOrMobile() ? "https://m.mintstech.cn" : "https://mintstech.cn",
              else: isPcOrMobile() ? "https://m.mintstech.io" : "https://mintstech.io",
              normal: isPcOrMobile() ? "https://m.mintstech.cn" : "https://mintstech.cn",
            },
            "m.mintstech.io": {
              zh: isPcOrMobile() ? "https://m.mintstech.cn" : "https://mintstech.cn",
              else: isPcOrMobile() ? "https://m.mintstech.io" : "https://mintstech.io",
              normal: isPcOrMobile() ? "https://m.mintstech.io" : "https://mintstech.io",
            },
          }
          var html = ''
          if (!isPcOrMobile()) {
            if (window.location.pathname == '/') {
              html = ''
            } else {
              html = '.html'
            }
          }
          for (var i in jumpUrlObj) {
            if (window.location.href.indexOf(i) != -1) {
              if (result.data > 0) {
                // 大陆登录
                window.location.href = jumpUrlObj[i].zh + window.location.pathname + html + window
                  .location.search
              } else if (result.data == 0) {
                // 非大陆登录
                window.location.href = jumpUrlObj[i].else + window.location.pathname + html + window
                  .location.search
              } else if (result.data == -1) {
                // 不处理ip跳转，仅处理端跳转
                if (window.location.href.indexOf(jumpUrlObj[i].normal) == -1) {
                  window.location.href = jumpUrlObj[i].normal + window.location.pathname + html + window
                    .location.search
                }
              }
              break
            }
          }


          return result

        } else if (result.code == 3 || result.code == 4) {
          return result
        } else if (result.code == 101) {
          if (u.indexOf('mints') == -1) {
            vm.showIsModal();//显示kyc弹窗
          }
          return result
        } else {

          return result
        }
      }
    }).catch(function (e) {

      return e
    })
  },
}
export default {
  fetchql,
  sendThis,
}



// WEBPACK FOOTER //
// ./src/common/fetch.js